
// @ts-nocheck
import locale_en_46ts_55f105a4 from "#nuxt-i18n/55f105a4";
import locale_nl_46ts_a323bd2b from "#nuxt-i18n/a323bd2b";
import locale_de_46ts_171bdd4b from "#nuxt-i18n/171bdd4b";

export const localeCodes =  [
  "en",
  "nl",
  "de"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46ts_55f105a4",
      load: () => Promise.resolve(locale_en_46ts_55f105a4),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46ts_a323bd2b",
      load: () => Promise.resolve(locale_nl_46ts_a323bd2b),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46ts_171bdd4b",
      load: () => Promise.resolve(locale_de_46ts_171bdd4b),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/8500e775" /* webpackChunkName: "config_i18n_46config_46ts_8500e775" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/home/vsts/work/1/s/src/gmp-swa/i18n/locales/en.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      name: "Nederlands",
      files: [
        {
          path: "/home/vsts/work/1/s/src/gmp-swa/i18n/locales/nl.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutschland",
      files: [
        {
          path: "/home/vsts/work/1/s/src/gmp-swa/i18n/locales/de.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/home/vsts/work/1/s/src/gmp-swa/i18n/locales/en.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Nederlands",
    files: [
      {
        path: "/home/vsts/work/1/s/src/gmp-swa/i18n/locales/nl.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutschland",
    files: [
      {
        path: "/home/vsts/work/1/s/src/gmp-swa/i18n/locales/de.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/